import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import router from '@/router/index.js'
import App from './App.vue'
import i18n from './language/index.js'
import 'swiper/dist/css/swiper.min.css';
import 'swiper/dist/js/swiper.min';
import '@/styles/theme-blue.css';
import '@/styles/page-layout.css';
import jquery from "jquery"


import VueLuckyCanvas from '@lucky-canvas/vue'
Vue.use(VueLuckyCanvas)
Vue.use(ElementUI);

Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    let ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden');
    });
  }
});

// PWA：尽早拦截安装事件，供下载页一键添加到桌面
window.__pwaDeferredPrompt = null
window.addEventListener('beforeinstallprompt', (e) => {
	e.preventDefault()
	window.__pwaDeferredPrompt = e
	window.dispatchEvent(new CustomEvent('pwa-installable'))
})
window.addEventListener('appinstalled', () => {
	window.__pwaDeferredPrompt = null
	window.dispatchEvent(new CustomEvent('pwa-installed'))
})

if ('serviceWorker' in navigator) {
	window.addEventListener('load', () => {
		navigator.serviceWorker.register(`${process.env.BASE_URL}sw.js`).catch((err) => {
			console.log('SW register failed', err)
		})
	})
}

function ensureTelegramFullscreen() {
	if (typeof window.__tgEnterFullscreen === 'function') {
		window.__tgEnterFullscreen()
		return
	}
	const tg = window.Telegram && window.Telegram.WebApp
	if (!tg) return
	try {
		tg.ready()
		if (typeof tg.expand === 'function') tg.expand()
		if (typeof tg.requestFullscreen === 'function' && !tg.isFullscreen) {
			tg.requestFullscreen()
		}
	} catch (e) {
		// ignore
	}
}

ensureTelegramFullscreen()
document.addEventListener('visibilitychange', () => {
	if (document.visibilityState === 'visible') ensureTelegramFullscreen()
})

new Vue({
	render: h => h(App),
	router,
	jquery,
	i18n,
	mounted() {
		ensureTelegramFullscreen()
	},
}).$mount('#app')
